import axios from 'axios';
import { getAccessTokenJWT } from 'utils/okta';
import { appConfig } from 'config/appConfig';
import { epochToISOFormat } from 'utils/date';
import okta from 'constants/okta';

const APIEndpoint = 'user';

let controller = new AbortController();

export const getUsers = (text) => {
  controller.abort();

  controller = new AbortController();

  return axios({
    method: 'get',
    url: appConfig.API_URL + '/' + APIEndpoint,
    signal: controller.signal,
    headers: {
      Authorization: okta.Bearer + getAccessTokenJWT(),
      'subscription-key': appConfig.API_SUBSCRIPTION_KEY,
    },
    params: {
      text,
    },
  })
    .then((response) => response.data)
    .catch((error) => {
      // TO-DO. Logging
      // control 401. okta redirection
      console.error(error);
      throw Error(error);
    });
};

export const updateUser = async (user) => {
  controller.abort();
  controller = new AbortController();

  const {
    id, email, updatedAt, name, imageUrl, lastLogin
  } = user;

  const payload = {
    Id: id,
    Name: name,
    Email: email,
    ImageUrl: imageUrl,
    LastLogin: lastLogin,
    UpdatedAt: updatedAt
  }

  return axios({
    method: 'put',
    url: appConfig.API_URL + '/' + APIEndpoint,
    signal: controller.signal,
    headers: {
      Authorization: okta.Bearer + getAccessTokenJWT(),
      'subscription-key': appConfig.API_SUBSCRIPTION_KEY,
    },
    data: payload,
  })
    .then((response) => response.data)
    .catch((error) => {
      if (axios.isCancel(error)) return;
      // TO-DO. Logging
      // control 401. okta redirection
      console.error(error);
      throw Error(error);
    });
};

export const updateUserLastLogin = async (user) => {
  const userUpdated = { ...user, lastLogin: epochToISOFormat(new Date(), true) };
  await updateUser(userUpdated);
  return userUpdated;
};
